import PrimaryButton from "../../../../../../common/components/primary_button";

/**
 * ConfigureLoginStepFour
 */

type Props = {
  userExisting: boolean,
  onClick?: () => void,
};

export const ConfigureLoginStepFour = ({
  userExisting,
  onClick,
}: Props) => {
  return (
    <>
      <div className="text-black dark:text-white w-full mt-8 flex flex-col gap-4">
        <h1 className="text-3xl font-semibold">
          {
            userExisting === true
              ? "Este login já foi configurado anteriormente."
              : "O seu acesso ao novo sistema foi configurado com sucesso!"
          }
        </h1>
        <p className="text-sm font-regular">
          Faça login para começar a utilizar o sistema.
        </p>
      </div>
      <div className="w-full flex justify-end my-10">
        <div className="w-44">
          <PrimaryButton onClick={onClick}>
            Fazer login
          </PrimaryButton>
        </div>
      </div>
    </>
  );
};